// extracted by mini-css-extract-plugin
export var footerContainer = "index-module--footerContainer--2wAaK";
export var footerListContent = "index-module--footerListContent--1Cq8W";
export var grotto = "index-module--grotto--1yzdp";
export var iconContainer = "index-module--iconContainer--2ocFO";
export var icon = "index-module--icon--3HC5o";